<template>
  <footer class="bg-[#0a0a33] text-white pt-20 pb-10 border-t border-white/5" data-aos="fade-up">
    <div class="container mx-auto px-6 lg:px-20 grid grid-cols-1 md:grid-cols-3 gap-12">
      
      <div class="space-y-6">
        <router-link to="/" class="flex items-center space-x-3 active:scale-95 transition-transform duration-300">
          <div class="p-2 bg-white/5 rounded-2xl backdrop-blur-md">
            <img :src="require('@/assets/images/novalingua.png')" alt="logo-novalingua" class="w-12 h-12 object-contain" />
          </div>
          <span class="text-2xl font-bold tracking-tight text-white">NovaLingua</span>
        </router-link>
        <p class="text-[15px] text-gray-400 leading-relaxed max-w-sm font-light">
          Nous offrons des formations de qualité pour développer vos compétences linguistiques et culturelles à travers nos différents centres au Cameroun.
        </p>
      </div>

      <div class="space-y-6">
        <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-[0.2em]">Navigation</h3>
        <ul class="space-y-4">
          <li v-for="link in navigationLinks" :key="link.name">
            <router-link :to="link.path" class="text-[15px] text-gray-300 hover:text-blue-400 transition-colors duration-300 flex items-center group">
              <span class="bg-blue-400 w-0 h-[1px] group-hover:w-4 transition-all duration-300 mr-0 group-hover:mr-2"></span>
              {{ link.name }}
            </router-link>
          </li>
        </ul>
      </div>

      <div class="space-y-8">
        <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-[0.2em]">Nos Centres</h3>
        
        <div class="grid gap-6">
          <div class="group p-4 rounded-2xl bg-white/[0.03] border border-white/[0.05] hover:bg-white/[0.06] transition-all duration-500">
            <h4 class="text-blue-400 font-semibold text-sm mb-2 flex items-center gap-2">
              <span class="w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse"></span>
              Bafoussam
            </h4>
            <div class="text-[13px] text-gray-400 space-y-1 font-light">
              <p class="flex items-center gap-2">📞 <span class="group-hover:text-white transition">+237 656 53 12 25</span></p>
              <p class="flex items-start gap-2">📍 <span>Entrée Marché Bafoussam, à droite du collège Pointe</span></p>
            </div>
          </div>

          <div class="group p-4 rounded-2xl bg-white/[0.03] border border-white/[0.05] hover:bg-white/[0.06] transition-all duration-500">
            <h4 class="text-blue-400 font-semibold text-sm mb-2 flex items-center gap-2">
              <span class="w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse"></span>
              Dschang
            </h4>
            <div class="text-[13px] text-gray-400 space-y-1 font-light">
              <p class="flex items-center gap-2">📞 <span class="group-hover:text-white transition">+237 695 63 20 89</span></p>
              <p class="flex items-start gap-2">📍 <span>En Face l'entree de la Chefferie Foto, dans l'immeuble abritant la boulangerie la paix et  la pharmacie de l'unite au 2eme etage</span></p>
            </div>
          </div>
        </div>

        <div class="pt-2 flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <a href="https://www.facebook.com/share/18qPBsXDeB/?mibextid=wwXIfr" target="_blank"
              class="w-10 h-10 bg-white/5 hover:bg-blue-600 flex items-center justify-center rounded-xl transition-all duration-300 hover:-translate-y-1 shadow-lg">
              <img :src="require('@/assets/icons/facebook.png')" alt="fb" class="w-5 h-5 invert opacity-80" />
            </a>
            <a href="https://www.instagram.com/novalinguabafoussam?igsh=MWQ5dng3ZG5xbXp2Yw==" target="_blank"
              class="w-10 h-10 bg-white/5 hover:bg-gradient-to-tr from-yellow-500 to-purple-600 flex items-center justify-center rounded-xl transition-all duration-300 hover:-translate-y-1 shadow-lg">
              <img :src="require('@/assets/icons/instagram.png')" alt="ig" class="w-5 h-5 invert opacity-80" />
            </a>
          </div>
          <a href="mailto:novalinguabafoussam@gmail.com" class="text-xs text-gray-500 hover:text-white transition-colors underline-offset-4 hover:underline">
            novalinguabafoussam@gmail.com
          </a>
        </div>
      </div>
    </div>

    <div class="mt-20 border-t border-white/5">
      <div class="container mx-auto px-6 lg:px-20 py-8 flex flex-col md:flex-row justify-between items-center text-[12px] text-gray-500 gap-6 font-light">
        <div class="tracking-wide italic opacity-80">
          © {{ annee }} <span class="font-semibold not-italic">NovaLingua</span>. Tous droits réservés.
        </div>

        <div class="flex flex-wrap justify-center gap-8">
          <a href="#" class="hover:text-white transition-colors underline-offset-4 hover:underline">Politique de confidentialité</a>
          <a href="#" class="hover:text-white transition-colors underline-offset-4 hover:underline">Conditions d’utilisation</a>
          <a href="#" class="hover:text-white transition-colors underline-offset-4 hover:underline">Mentions légales</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { onMounted, ref } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

const annee = ref(new Date().getFullYear());

const navigationLinks = [
  { name: "Accueil", path: "/" },
  { name: "À propos", path: "/apropos" },
  { name: "Partenaires", path: "/partenaires" },
  { name: "Contact", path: "/contact" }, // Assurez-vous que le path correspond
];

onMounted(() => {
  AOS.init({
    duration: 1000,
    once: true,
  });
});
</script>

<style scoped>
/* Lissage des polices pour le mode sombre */
footer {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Effet d'inversion pour les icônes si elles sont noires à l'origine */
.invert {
  filter: brightness(0) invert(1);
}

/* Animation douce pour le trait des liens */
.group:hover span {
  margin-right: 0.5rem;
}
</style>